"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHeadline(resultCode) {
    switch (resultCode) {
        case 'YYN':
        case 'YYY':
        case 'YNY':
        case 'YNN':
            return 'awardEarnedHeader';
        case 'YXN':
        case 'YXY':
            return 'noAwardHeader';
        default:
            return '';
    }
}
exports.getHeadline = getHeadline;
function getSubHeadline(resultCode) {
    switch (resultCode) {
        case 'YYN':
        case 'YNN':
        case 'YYY':
        case 'YNY':
            return 'awardEarnedSubhead';
        case 'YXN':
        case 'YXY':
            return 'noAwardSubhead';
        default:
            return '';
    }
}
exports.getSubHeadline = getSubHeadline;
function getMessage(resultCode) {
    switch (resultCode) {
        case 'YYN':
            return 'multiPaxGoalAchievedMessage';
        case 'YNN':
            return 'singlePaxGoalAchievedMessage';
        case 'YYY':
            return 'multiPax%ofGoalAchievedMessage';
        case 'YNY':
            return 'singlePax%ofGoalAchievedMessage';
        default:
            return '';
    }
}
exports.getMessage = getMessage;
//# sourceMappingURL=manager-codes.js.map